import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError.js';
import { Toast } from '../../../../../Notification/index.js';


export const logStart = async ({userId, resource, day, logJobStart}) => {
  const operation = 1; // 1 = create
  try {
    await logJobStart(userId, operation);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      console.log(error);
      let notification = {
        type: 'error',
        message: "Logging Job Start Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
      Toast(notification); // only notify on error
    }
  }
}

export const logFinish = async ({resource, logControlId, jobId, day, logJobFinish}) => {
    try {
      await logJobFinish(logControlId, jobId);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        console.log(error);
        let notification = {
          type: 'error',
          message: "Logging Job Finish Error",
          description: `For [${resource.name} on ${day}]: ${parseError(error)}`
        };
        Toast(notification); // only notify on error
      }
    }
}

export const createJob = async ({resource, logControlId, userId, itemDetails, addJob, day, updateState}) => {
  const { jobTitle, assignmentStartTime } = itemDetails;
  const { costObject } = itemDetails;
  let parameters = {
    creatingUserId: userId,
    updatingUserId: userId,
    costObjectId: costObject.id,
    costObjectTypeId: costObject.costObjectTypeId,
    jobTitle,
    baseDate: assignmentStartTime.format('YYYY-MM-DD HH:mm:ss'),
    startRequest: assignmentStartTime.format('YYYY-MM-DD HH:mm:ss'),
    logControlId
  };
  let notification = {type: 'success', message: 'Request Added', description: `For ${resource.name} on ${day}`};
  try {
    await addJob(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: true
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Adding Request Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
/**
 * since this is only getting called within the context of creating an assignment (jobElement)
 * no need to refresh page ever, regresh will depend on result of createJobElement method below
 */
}

export const createJobElement = async ({resource, logControlId, userId, itemDetails, addJobElement, day, state, updateState, refreshPage}) => {
  const { jobId, tourId, executingBranchId, serviceId, relatedServiceId,
    status, assignmentStartTime, assignmentEndTime, timeZoneId,
    descriptionComment, isAnUpgrade, overTime, activityType, costObject,
    jobSalaryUpgradeId, hourlyActivityRateFlag, rate } = itemDetails;
    const parameters = {
      jobId,
      executingBranchId,
      tourId: tourId || 0, // 0 for standby Assignment
      serviceId,
      resourceId: resource.id,
      relatedServiceId,
      status,
      startRequest: assignmentStartTime.format('YYYY-MM-DD'),
      endRequest: assignmentEndTime.format('YYYY-MM-DD'),
      startActual: assignmentStartTime.format('YYYY-MM-DD HH:mm:ss'),
      endActual: assignmentEndTime.format('YYYY-MM-DD HH:mm:ss'),
      timeZoneId,
      orderingUserId: userId,
      updatingUserId: userId,
      comment: descriptionComment,
      isAnUpgrade: isAnUpgrade || false,
      overTime: overTime || false,
      activityType,
      costObjectId: costObject ? costObject.id : 0,
      costObjectTypeId: costObject ? costObject.costObjectTypeId : 0,
      jobSalaryUpgradeId: jobSalaryUpgradeId || 0,
      hourlyActivityRateFlag: hourlyActivityRateFlag || false,
      rate: rate || 0,
      logControlId
    };
    let notification = {type: 'success', message: 'Assignment Added', description: `For ${resource.name} on ${day}`};
    try {
      await addJobElement(parameters);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        updateState({
          crudError: {
            failedAction: 'addJobElement',
            message: parseError(error)
          }
        });
        console.log(error);
        notification = {
          type: 'error',
          message: "Adding Assignment Error",
          description: `For [${resource.name} on ${day}]: ${parseError(error)}`
        };
      }
    }
    Toast(notification);
    updateState({
      crudLoading: false // allows page refresh after addJobElement completes
    });
    refreshPage();
}

